import { render, staticRenderFns } from "./myloading.vue?vue&type=template&id=5f903212"
import script from "./myloading.vue?vue&type=script&lang=js"
export * from "./myloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports